import { render, staticRenderFns } from "./app-icon.vue?vue&type=template&id=1edffb96&scoped=true&"
import script from "./app-icon.vue?vue&type=script&lang=js&"
export * from "./app-icon.vue?vue&type=script&lang=js&"
import style0 from "./app-icon.vue?vue&type=style&index=0&id=1edffb96&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edffb96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1edffb96', component.options)
    } else {
      api.reload('1edffb96', component.options)
    }
    module.hot.accept("./app-icon.vue?vue&type=template&id=1edffb96&scoped=true&", function () {
      api.rerender('1edffb96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/app-icon.vue"
export default component.exports